import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

export interface Transaction {
  id: number;
  amount: number;
  coins_earned: number;
  payment_status: string;
  created_at: string;
  description?: string;
  type?: string;
}

export interface UserWallet {
  balance: number;
  coins: number;
  locked_balance: number;
  total_earned: number;
  total_withdrawn: number;
  reader_balance?: number; 
  available_balance?: number;
  writer_earnings?: number; // Naya field add kiya
}

export interface WriterProgress {
  stories_count: number;
  episodes_count: number;
  total_views: number;
  followers_count: number;
  is_unlocked: boolean;
  completed_stories: any[];
  total_stories: number;
}

export interface WalletData {
  status: string;
  reader_wallet?: UserWallet;
  writer_wallet?: UserWallet;
  writer_progress?: WriterProgress;
  reader_transactions?: Transaction[];
  writer_transactions?: Transaction[];
}

// Writer Earnings Interface
export interface WriterEarnings {
  status: string;
  total_earnings: number;
  available_balance: number;
  total_transferred: number;
  total_episodes_sold: number;
  writer_earnings?: number;
}

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  private baseUrl = 'https://stories.funtelstudio.com/storyapi';

  constructor(private http: HttpClient, private authService: AuthService) { }

  getWalletData(type: string = 'all'): Observable<WalletData> {
    return this.http.get<WalletData>(`${this.baseUrl}/get_wallet_data.php?type=${type}`, {
      withCredentials: true
    });
  }

  // Writer earnings get karo
  getWriterEarnings(): Observable<WriterEarnings> {
    const userId = this.authService.getCurrentUserId();
    return this.http.get<WriterEarnings>(`${this.baseUrl}/get_writer_earnings.php?user_id=${userId}`, {
      withCredentials: true
    });
  }

  transferToReader(amount: number) {
    const userId = this.authService.getCurrentUserId();
    return this.http.post<any>('https://stories.funtelstudio.com/storyapi/transfer_wallet_funds.php', {
      user_id: userId,
      amount: amount
    }, {
      withCredentials: true
    });
  }

  withdrawFunds(amount: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/withdraw_funds.php`, {
      amount: amount
    }, {
      withCredentials: true
    });
  }

  unlockWriterBalance(): Observable<any> {
    return this.http.post(`${this.baseUrl}/unlock_writer_balance.php`, {}, {
      withCredentials: true
    });
  }
}